module.exports = "/_next/static/images/nmc-c5729aa84ca2f0301244f25fae21e680.svg";